export default __webpack_public_path__ + "static/media/avatar.b45ae01d.png";